module.exports = __webpack_public_path__ + "static/media/giftCard.428cc686.png";